export default __webpack_public_path__ + "static/media/center.e90633c6.svg";